// import Vue from "vue";

// import SxCommonDialog from "sx-common-dialog";
// import "sx-common-dialog/theme-default/lib/index.css";
import { h } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import lodash from "lodash";
import store from "@store/tender";
import { accSub, accAdd } from "@/common/js/utils";
import api from "@/common/js/api";
const validate_1 = (obj, params, value, callback, form) => {};
const valid_Pattern = (obj, params, value, callback, form) => {
  console.log(obj, params, value, form);
  if (!params[0].test(value)) {
    callback(new Error("111"));
  } else {
    callback();
  }
};
const __temp__ = {};
/* 投资项目统一代码 */
const INVEST_PROJECT_CODE = (obj, params, value, callback, form) => {
  let key = obj.Key;
  // console.log(obj, params, value, form);
  if (form.RELATE_CODE === "0") {
    callback();
  } else {
    let flag = /^.{24}$/.test(form[key]);
    if (!flag) {
      callback(new Error("请输入24位"));
    } else {
      callback();
    }
  }
};
/* 项目法人代码 */
const societyCode = (value) => {
  let arr = value.split("");
  let Ci = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    J: 18,
    K: 19,
    L: 20,
    M: 21,
    N: 22,
    P: 23,
    Q: 24,
    R: 25,
    T: 26,
    U: 27,
    W: 28,
    X: 29,
    Y: 30,
  };
  let Wi = {
    1: 1,
    2: 3,
    3: 9,
    4: 27,
    5: 19,
    6: 26,
    7: 16,
    8: 17,
    9: 20,
    10: 29,
    11: 25,
    12: 13,
    13: 8,
    14: 24,
    15: 10,
    16: 30,
    17: 28,
  };
  let cw = [],
    cwAdd = 0;

  arr.forEach((item, index) => {
    // cw.push(accMul(parseInt(item)+'',Wi[index]+''))
    if (index !== 17) {
      cw.push(parseInt(Ci[item]) * Wi[index + 1]);
    }
  });

  cw.forEach((item) => {
    cwAdd += parseInt(item);
  });
  // console.log(cw)
  // console.log(cwAdd)
  // console.log(31-cwAdd%31,arr[17],31-cwAdd%31===parseInt(arr[17]))
  // console.log(31 - (cwAdd % 31), arr[17]);
  return (31 - (cwAdd % 31)) % 31 === parseInt(Ci[arr[17]]);
};
const fnValidOrgCode = (value) => {
  let arr = value.split("");
  let Ci = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  let Wi = [3, 7, 9, 10, 5, 8, 4, 2];
  let sum = 0;
  let last = arr.pop();
  arr.forEach((v, k) => {
    sum += Ci.indexOf(v) * Wi[k];
  });
  sum = (11 - (sum % 11)) % 11;
  return sum === 10 ? last === "X" : last - sum === 0;
};
const LEGAL_PERSON_CODE = (obj, params, value, callback, form) => {
  let key = obj.Key;
  // console.log(obj, params, value, form);
  form[key] = form[key].trim();
  if (form[key] === "") {
    callback(new Error("请输入"));
  } else if (form[key].length !== 9 && form[key].length !== 18) {
    callback(new Error("请输入9位或18位代码"));
  } else if (form[key].length === 9) {
    if (!fnValidOrgCode(form[key])) {
      callback(new Error("请输入正确的9位代码"));
    } else {
      callback();
    }
  } else if (form[key].length === 18) {
    // console.log(form[key],new RegExp(/[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g).test(value))
    if (!new RegExp(/[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g).test(form[key])) {
      callback(new Error("请输入正确的18位代码"));
    } else if (!societyCode(form[key])) {
      callback(new Error("请输入正确的18位代码"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};

/*重新招标原招标项目编号  */
const REBID_TENDER_PROJECT_CODE = (obj, params, value, callback, form) => {
  let key = obj.Key;
  // console.log(obj, params, value, form);
  if (form.IS_REBID == "1") {
    let flag = /^.{20}$/.test(form[key]);
    if (!flag) {
      callback(new Error("请输入20位"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};

/* 招标人代码 */
const TENDERER_CODE = (obj, params, value, callback, form) => {
  let key = obj.Key;
  // console.log(obj, params, value, form);
  if (form.regionId.indexOf("3502") === 0) {
    let flag = /^[a-zA-Z0-9]{18}$/.test(value);
    if (!flag) {
      callback(new Error("请输入18位"));
    } else {
      callback();
    }
  } else {
    let flag = /^[a-zA-Z0-9]{18}$/.test(value);
    if (!flag) {
      callback(new Error("请输入18位"));
    } else {
      callback();
    }
  }
};
/* 监督部门名称 */
const SUPERVISE_DEPT_NAME = (obj, params, value, callback, form) => {
  let key = obj.Key;
  // console.log(obj, params, value, form);
  if (value === "/" || value === "") {
    callback(new Error("不能填写/"));
  } else {
    callback();
  }
};

/* 最高控制价 */
/* 防抖函数 */
// const CONTROL_PRICE_debounce = lodash.debounce((msg) => {
//   ElMessageBox({
//     title: "提示",
//     type: "waning",
//     closeOnClickModal: false,
//     message: h("p", { style: "font-weight:bolder;line-height:32px;font-size:16px;" }, [
//       h("span", {}, "您填写的字段单位是"),
//       h("span", { style: "color:red;" }, "元"),
//       h("span", {}, "，当前输入金额"),
//       h("span", { style: "color:red;" }, msg),
//       h("span", {}, "，请确认金额是否正确，正确则忽略本条提示，不正确请自行修改为正确金额"),
//     ]),
//     showCancelButton: false,
//     confirmButtonText: "已了解",
//   }).then(() => {});
// }, 1000);
const CONTROL_PRICE = (obj, params, value, callback, form) => {
  // console.log(123123, form.CONTROL_PRICE, accAdd(form.COMPETITION_PRICE, form.NON_COMPETITION_PRICE));
  let key = obj.Key;
  if (value) {
    setTimeout(() => {
      if (
        form.COMPETITION_PRICE != "" &&
        form.NON_COMPETITION_PRICE != "" &&
        form.CONTROL_PRICE != accAdd(form.COMPETITION_PRICE, form.NON_COMPETITION_PRICE)
      ) {
        callback(new Error("最高控制价=可竞争金额+不可竞争金额"));
      } else {
        callback();
      }
    }, 0);
  } else {
    form.COMPETITION_PRICE = "";
    form.NON_COMPETITION_PRICE = "";
    form.PROVISIONAL_SUM = "";
    form.PROVISIONAL_ESTIMATE = "";
    form.OTHER_ESTIMATE = "";
    callback();
  }
};
/* 最高控制价相关联的字段（可竞争不可竞争暂列金暂估价其它） */
const CONTROL_PRICE_LINK = (obj, params, value, callback, form) => {
  let key = obj.Key;
  if (form.PROVISIONAL_SUM != "" && form.PROVISIONAL_ESTIMATE != "" && form.OTHER_ESTIMATE != "") {
    form.NON_COMPETITION_PRICE = accAdd(accAdd(form.PROVISIONAL_SUM, form.PROVISIONAL_ESTIMATE), form.OTHER_ESTIMATE);
    form.NON_COMPETITION_PRICE = isNaN(parseFloat(form["NON_COMPETITION_PRICE"])) ? "" : parseFloat(form["NON_COMPETITION_PRICE"]).toFixed(0);
  }

  if (form.CONTROL_PRICE == "") {
    form[key] = "";
    callback();
  } else if (form[key] == "") {
    callback(new Error(" "));
  } else {
    callback();
  }
};

/* 保证金缴纳方式 */
const MARGIN_PAY_TYPE_label = (obj, params, value, callback, form) => {
  let key = obj.Key;

  console.log(obj, params, value, form);
};
/* k值区间 */
const K_NUM = (obj, params, value, callback, form) => {
  let key = obj.Key;
  // console.log(obj, params, value, form);
  let flag = new RegExp(`(^0\\.[0-9]{2}$)|(^[1-9][0-9]*\\.[0-9]{2}$)`);
  let min = params[0],
    max = params[1],
    range = params[2];
  if (!flag.test(value)) {
    callback(new Error("请保留2位小数"));
  } else if (value < min || value > max) {
    callback(new Error(`取${min}%～${max}%值区间`));
  } else if (form.K_BEGIN_NUM && form.K_END_NUM && parseFloat(form.K_BEGIN_NUM) > parseFloat(form.K_END_NUM)) {
    callback(new Error(`起始值应小于结束值`));
  } else if (parseFloat(form.K_END_NUM) - parseFloat(form.K_BEGIN_NUM) < range) {
    callback(new Error(`区间幅度不小于${range}%`));
  } else {
    callback();
  }
};
/* 厦门其它章节中的资金字段验证 */
const SOURCEGOV = (obj, params, value, callback, form) => {
  let flag = new RegExp(`^[0-9]{1,15}(.[0-9]{1,9})?$`);
  let total =
    parseFloat(form.SOURCEGOV) +
    parseFloat(form.SOURCESTATE) +
    parseFloat(form.SOURCECOLLECTIVE) +
    parseFloat(form.SOURCEOUT) +
    parseFloat(form.SOURCEPRIVATE) +
    parseFloat(form.SOURCEOTHER);
  if (!flag.test(value)) {
    callback(new Error("请输入数字，长度不超过17位"));
  } else if (
    form.SOURCEGOV !== "" &&
    form.SOURCESTATE !== "" &&
    form.SOURCECOLLECTIVE !== "" &&
    form.SOURCEOUT !== "" &&
    form.SOURCEPRIVATE !== "" &&
    form.SOURCEOTHER !== "" &&
    total > 100
  ) {
    callback(new Error("资金来源构成所有占比率总和不能超过100"));
  } else {
    callback();
  }
};
/* 泉州 厦门特殊字段 */
const PERFORM_PRICE_MONEY = (obj, params, value, callback, form) => {
  let key = obj.Key;
  // console.log(obj, params, value, form, 111);
  if (form.regionId.indexOf("3505") == 0) {
    let flag = new RegExp(/(^[1-9]\d*(\.\d+)?$)|(^0(\.\d+)?$)/);
    if (!flag.test(value)) {
      callback(new Error("请输入数字"));
    } else {
      callback();
    }
  } else if (form.regionId.indexOf("3502") == 0) {
    let flag = new RegExp(/^[0-9]+(.[0-9]{1,4})?$/);
    if (!flag.test(value)) {
      callback(new Error("请输入数字,最多保留4位小数"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
/* 场地预约编号 */
const SITE_BOOKING_NUM_Change = {
  first_SITE_BOOKING_NUM: "",
  host: "",
  msg: "",
  valid(form, key, callback) {
    if (this.first_SITE_BOOKING_NUM == form[key]) {
      if (this.msg == "") {
        callback();
      } else {
        callback(new Error(this.msg));
      }
      setTimeout(() => {
        store.dispatch("calcTenderCount");
      }, 100);
    } else {
      this.first_SITE_BOOKING_NUM = form[key];
      if (form[key]) {
        api
          .get(this.host + "/Api/v1/Book/ExistValidOrder", {
            Id: form[key],
          })
          .then((res) => {
            // console.log(store);
            // resolve();
            if (res.status == 0) {
              if (res.order.fetchCenterInfoStatus && res.order.state == 200) {
                if (res.order.centerData.id == form.OPEN_BID_SITE) {
                  var extraData = JSON.parse(res.order.centerData.extraData);
                  form.BID_OPEN_PLACE = extraData.Address;
                  this.msg = "";
                  callback();
                } else {
                  this.msg = "该编号与开标场地不匹配，请重新填写";
                  callback(new Error(this.msg));
                }
              } else {
                var state = "";
                switch (res.order.state) {
                  case 3:
                    state = "取消";
                    break;
                  case 4:
                    state = "退回";
                    break;
                  case 5:
                    state = "使用";
                    break;
                  case 6:
                    state = "临时预约";
                    break;
                  default:
                    state = "审核中";
                    break;
                }
                const h = that.$createElement;
                ElMessageBox({
                  title: "数据验证",
                  closeOnClickModal: false,
                  type: "warning",
                  showCancelButton: false,
                  confirmButtonText: "确定",
                  message: h("p", { style: "font-weight:bolder" }, [
                    h("span", null, "当前预约订单状态为"),
                    h("span", { style: "color: red" }, state),
                    h("span", null, "状态，不可使用，请重新输入订单状态为"),
                    h("span", { style: "color: red" }, "预约成功"),
                    h("span", null, "的场地预约编号！"),
                  ]),
                }).then(() => {
                  ElMessage.warning("请填写有效的场地预约编号！");
                });
                this.msg = "请填写有效的场地预约编号";
                callback(new Error(this.msg));
              }
            } else {
              // ElMessage({
              //   type: "warning",
              //   message: res.msg,
              // });
              this.msg = "请填写有效的场地预约编号";
              callback(new Error(res.msg || this.msg));
            }

            setTimeout(() => {
              store.dispatch("calcTenderCount");
            }, 100);
          }).catch(e => null);
      } else {
        this.msg = " ";
        callback(new Error(this.msg));
      }
    }
  },
};
const SITE_BOOKING_NUM_debounce = lodash.debounce((form, key, callback) => {
  if (!SITE_BOOKING_NUM_Change.host) {
    api.get("/static/config/siteBookingServelUrl.json", { t: Date.now() }).then((response) => {
      SITE_BOOKING_NUM_Change.host = response.siteBookingServelUrl;
      SITE_BOOKING_NUM_Change.valid(form, key, callback);
    });
  } else {
    SITE_BOOKING_NUM_Change.valid(form, key, callback);
  }
}, 500);
const SITE_BOOKING_NUM = (obj, params, value, callback, form) => {
  let key = obj.Key;

  // console.log(obj, params, value, form, 111);
  var reg = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
  var reg1 = new RegExp(/^[0-9a-f]{8}[0-9a-f]{4}[0-9a-f]{4}[0-9a-f]{4}[0-9a-f]{12}$/);
  if (reg.test(form[key]) || reg1.test(form[key])) {
    SITE_BOOKING_NUM_debounce(form, key, callback);
  } else {
    callback(new Error("请填写有效的场地预约编号"));
  }
};

/* 特殊的时间数组字段 */
const specialTime = (obj, params, value, callback, form) => {
  // console.log(params);
  let key = obj.Key;
  let targetKey = params[0],
    startKey = params[1],
    endKey = params[2];
  if (startKey && endKey) {
    if (form[startKey] && form[endKey]) {
      form[targetKey] = [form[startKey], form[endKey]];
    } else {
      form[targetKey] = [];
    }
  } else {
    if (form[targetKey + "_START"] && form[targetKey + "_END"]) {
      form[targetKey] = [form[targetKey + "_START"], form[targetKey + "_END"]];
    } else {
      form[targetKey] = [];
    }
  }

  if (form[key] == "") {
    callback(new Error(" "));
  } else {
    callback();
  }
};

export const customRule = (obj, args, value, callback, form) => {
  let [type, ...params] = args;
  // console.log(1213, type);
  // console.log(store._modulesNamespaceMap["waterStore/"].state.tenderProjectConfig.MARGIN_PAY_TYPE_2022);
  // if (obj.Key === "CONTROL_PRICE") debugger;
  switch (type) {
    case "INVEST_PROJECT_CODE":
      INVEST_PROJECT_CODE(obj, params, value, callback, form);
      break;
    case "LEGAL_PERSON_CODE":
      LEGAL_PERSON_CODE(obj, params, value, callback, form);
      break;
    case "REBID_TENDER_PROJECT_CODE":
      REBID_TENDER_PROJECT_CODE(obj, params, value, callback, form);
      break;
    case "TENDERER_CODE":
      TENDERER_CODE(obj, params, value, callback, form);
      break;
    case "SUPERVISE_DEPT_NAME":
      SUPERVISE_DEPT_NAME(obj, params, value, callback, form);
      break;
    case "CONTROL_PRICE":
      CONTROL_PRICE(obj, params, value, callback, form);
      break;
    case "CONTROL_PRICE_LINK":
      CONTROL_PRICE_LINK(obj, params, value, callback, form);
      break;
    case "MARGIN_PAY_TYPE_label":
      MARGIN_PAY_TYPE_label(obj, params, value, callback, form);
      break;
    case "K_NUM":
      K_NUM(obj, params, value, callback, form);
      break;
    case "SOURCEGOV":
      SOURCEGOV(obj, params, value, callback, form);
      break;
    case "PERFORM_PRICE_MONEY":
      PERFORM_PRICE_MONEY(obj, params, value, callback, form);
      break;
    case "SITE_BOOKING_NUM":
      SITE_BOOKING_NUM(obj, params, value, callback, form);
      break;
    case "specialTime":
      specialTime(obj, params, value, callback, form);
      break;
    default:
      callback();
      break;
  }
};
